/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { EventEmitter } from '@angular/core';

export interface ElCalendarDay {
  name: string;
  isHoliday: boolean;
}

export enum ElCalendarViewMode {
  YEAR = 'year',
  MONTH = 'month',
  DATE = 'date',
}

export enum ElCalendarSize {
  MEDIUM = 'medium',
  LARGE = 'large',
}

export interface ElCalendarCell<D, T> {
  date: D;
  select: EventEmitter<D>;
  selectedValue?: T;
  visibleDate?: D;
  min?: D;
  max?: D;
  filter?: (D) => boolean;
}
